var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WarehouseForm',{attrs:{"warehouse":_vm.warehouse,"buttonLoading":_vm.buttonLoading},on:{"saveWarehouse":_vm.saveWarehouse}})}
var staticRenderFns = []

export { render, staticRenderFns }